module.exports = __webpack_public_path__ + "static/media/tarot-card-10.55efc12c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/tarotcards/tarot-card-10.jpg
// module id = 1543
// module chunks = 0